const talks = [
  {
    num: "01",
    title: "Designing Lives That Actually Fit",
    desc: "Rethinking productivity, capacity, and joy for leaders and teams.",
  },
  {
    num: "02",
    title: "Trusting the Path You Cannot See...Yet",
    desc: "Leading and living through seasons of uncertainty.",
  },
  {
    num: "03",
    title: "Before the World Told You Who to Be",
    desc: "Reclaiming alignment and voice during seasons of transition.",
  },
];

export function Keynotes() {
  return (
    <section
      data-testid="keynotes-section"
      className="relative overflow-hidden"
      style={{ background: "linear-gradient(180deg, #F8F7F5 0%, #FFFFFF 15%, #FFFFFF 85%, #F8F7F5 100%)" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-12 md:pt-16 pb-10 md:pb-16">

        <div className="mb-10 md:mb-14 reveal">
          <p className="text-[11px] tracking-[0.28em] uppercase text-[#F6A041] mb-5 font-medium">
            Signature Keynotes
          </p>
          <h2 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight text-[#1C1917] max-w-lg">
            Topics that move rooms.
          </h2>
        </div>

        <div className="divide-y divide-[#E8E6E3]">
          {talks.map((t, i) => (
            <article
              key={i}
              data-testid={`keynote-${i}`}
              className="reveal grid grid-cols-12 gap-4 md:gap-8 py-20 md:py-24 group"
            >
              <div className="col-span-3 md:col-span-2">
                <span className="font-display text-[80px] md:text-[108px] lg:text-[128px] text-[#EBEBEA] group-hover:text-[#F6A041] transition-colors duration-500 leading-none select-none">
                  {t.num}
                </span>
              </div>
              <div className="col-span-9 md:col-span-10 flex flex-col lg:flex-row lg:items-baseline lg:gap-16 pt-2 md:pt-4">
                <h3 className="font-display text-[40px] md:text-[54px] text-[#1C1917] leading-snug mb-4 lg:mb-0 lg:min-w-[400px]">
                  {t.title}
                </h3>
                <p className="text-[22px] md:text-[26px] text-[#57534E] leading-relaxed">
                  {t.desc}
                </p>
              </div>
            </article>
          ))}
        </div>

      </div>
    </section>
  );
}
